import { AxiosInstance } from 'axios';

import { OptimizationAPIApiFactory } from '@cast/openapi-reporting';

import { AXIOS_CONFIGURATION } from '../constants';

export const OptimizationApiAdapter = (client: AxiosInstance) => {
  const generatedApi = OptimizationAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    listClusterOptimizations:
      generatedApi.optimizationAPIRunClusterOptimizationsReport,
  };
};
